import * as Sentry from '@sentry/angular';
import type { AppConfig } from '@shared/interfaces/app-config';
import { SENTRY_DSN_KEY } from '@shared/constants/common.constants';
import { isLocalhost } from '@3dsource/utils';
import { environment } from './environments/environment';

export const initSentry = (config: AppConfig) => {
  Sentry.init({
    environment: config.environment,
    dsn: SENTRY_DSN_KEY,
    enabled: !isLocalhost && !environment.playwright,
  });
};
